import React from 'react';
import type { RequestResultsStatus } from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { Banner, UtilityAlertIcon } from '@placer-ui/components';

import styles from './banner-section.module.scss';

const sensitiveBannerText =
    "All properties violate Placer's policy, a support ticket will not be created.";
const availableBannerText =
    'All properties are available in the platform and ready for analysis, a support ticket will not be created.';
const missingInfoBannerText =
    'Edit the highlighted cells that are missing information to continue processing.';

const getSuffix = (count: number) => (count > 1 ? 'ies are' : 'y is');

interface BannerSectionProps {
    statusMap: Record<RequestResultsStatus, number>;
}

export const BannerSection = ({ statusMap }: BannerSectionProps) => {
    const onlyOneStatus = Object.keys(statusMap).length === 1;
    const onlyAvailableStatus = onlyOneStatus && !!statusMap['Available'];
    const onlySensitiveStatus = onlyOneStatus && !!statusMap['SensitiveLocation'];
    const availableAndSensitiveStatus =
        Object.keys(statusMap).length === 2 &&
        !!statusMap['Available'] &&
        !!statusMap['SensitiveLocation'];

    const availableAndSensitiveBannerText = `${statusMap['Available']} Propert${getSuffix(
        statusMap['Available'],
    )} available in the platform and ready for analysis
and ${statusMap['SensitiveLocation']} propert${getSuffix(
        statusMap['SensitiveLocation'],
    )} violate Placer's policy, a support ticket will not be created.`;

    return (
        <>
            {onlyAvailableStatus && (
                <span className={styles.bannerWrapper}>
                    <Banner testId="available-banner" text={availableBannerText} type="success" />
                </span>
            )}
            {onlySensitiveStatus && (
                <span className={styles.bannerWrapper}>
                    <Banner testId="sensitive-banner" text={sensitiveBannerText} type="primary" />
                </span>
            )}
            {availableAndSensitiveStatus && (
                <span className={styles.bannerWrapper}>
                    <Banner
                        testId="available-and-sensitive-banner"
                        text={availableAndSensitiveBannerText}
                        type="primary"
                    />
                </span>
            )}
            {!!statusMap?.['MissingInfo'] && (
                <span className={styles.bannerWrapper}>
                    <Banner
                        testId="missing-info-banner"
                        text={missingInfoBannerText}
                        type="warning"
                        LeftIcon={<UtilityAlertIcon />}
                    />
                </span>
            )}
        </>
    );
};
